import * as React from 'react';
import classNames from 'classnames';

export interface IErrorStateProps {
  className?: string;
  size?: 'small' | 'medium';
  title?: string;
  description?: string;
}

const ErrorState = ({
  className,
  size,
  title,
  description
}: IErrorStateProps) => {
  const titleClasses = classNames('fw6 m-0',
    size === 'small' ? 'f4' : 'f2',
  );
  const descriptionClasses = classNames('mt-2',
    size === 'small' ? 'f5' : 'f3',
  );

  return (
    <div className={classNames('p-12 text-center', className)}>
      <h2 className={titleClasses}>
        {title || 'Der opstod en uventet fejl'}
      </h2>
      {description && (
        <p className={descriptionClasses}>{description}</p>
      )}
    </div>
  );
}

export default ErrorState;



// WEBPACK FOOTER //
// ./src/components/ErrorState/index.tsx